import { isNil } from 'lodash';
import { useAppDispatch } from '../../../redux/hooks';
import { setReplaceReport } from '../../../redux/slices/cachedEntities';
import { assertCondition } from '../../../utils/types';
import { useChartContext } from '../ChartContext';
import { ChartMode } from '../types';
import { UnreachableCaseError } from 'ts-essentials';
import { useEffect } from 'react';

const ChartReplaceReportEffect = () => {
  const chartContext = useChartContext();
  assertCondition(chartContext.__typename === 'BaseChartContext');
  const {
    metadata: { mode, analysisId, container, reportLink, display },
    permissions,
  } = chartContext;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (mode !== ChartMode.Build) {
      return;
    }
    if (
      !isNil(container) &&
      permissions.entityPermissions.replaceAnalysisInContainer
    ) {
      if (container.__typename === 'AnalysisDashboardContainer') {
        dispatch(
          setReplaceReport({
            type: 'dashboard',
            name: container.name,
            targetAnalysisId: analysisId,
            targetAnalysisName: display,
            targetAnalysisLink: reportLink,
            baseId: container.baseId,
            instanceId: container.id,
          }),
        );
      } else if (container.__typename === 'AnalysisWorkspaceContainer') {
        dispatch(
          setReplaceReport({
            type: 'workspace',
            name: container.name,
            targetAnalysisId: analysisId,
            targetAnalysisName: display,
            targetAnalysisLink: reportLink,
            workspaceId: container.baseId,
          }),
        );
      } else {
        throw new UnreachableCaseError(container);
      }
    }
  }, [analysisId, reportLink, display, container, dispatch, permissions, mode]);

  return null;
};

export default ChartReplaceReportEffect;
